export const environment = {
  mapbox: {
    accessToken: 'pk.eyJ1Ijoidml2ZWttaXNocmEtY3BsdXMiLCJhIjoiY2w2dnM1dTg3MDFlZzNicDdmdWxvOGNwOSJ9.8laNCJkgJbgRoh7bVa9xKg'
  },
  FILE_STREAM_URL: 'https://dasasplace.com/BackendDASA-1.0.0/api/images/streamer/',
  STUART_URL: "https://dasasplace.com/BackendDASA-1.0.0/stuart/pricing",
  SOCKET_URL: "wss://www.dasasplace.com/BackendDASA-1.0.0/ws",
  // SOCKET_URL: "wss://localhost:9000/ws",
  NEW_BACKEND_URL: "https://dasasplace.com/BackendDASA-1.0.0/",
  // NEW_BACKEND_URL: "http://localhost:9000/",
  production: false,
  BROWSERSTACK_USERNAME: '',
  BROWSERSTACK_ACCESS_KEY: '',
  PAYPAL_USERNAME: '',
  PAYPAL_PASSWORD: '',
  //prod key
  STRIPE_PUBLISHATION_KEY:'pk_test_51QeII5Q1MjofPWgI5z0hyqIcRIoaeFitmm0uikiZVjgw2TFC0Cz5soa68YthptA8UsP9eXpY6HL1BQjuug42SQZR00vehyFyRn',
  //test key
  // STRIPE_PUBLISHATION_KEY:'pk_test_51QeII5Q1MjofPWgIwAySPWuJtMcnMiL2B1o5UPNIaHc6XxIkzhMiv4BA3Pe1cGeuDhkJXMjv75oCJzB5U9XVrDS300y0dVBozN',
  //STRIPE_SECRET_KEY: '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',
  //STRIPE_PUBLISHATION_KEY: 'pk_live_51M7gFiBkzC5Wbtnr2HskNcZeevKjZBfVMTS0NVPaKOaMV0VVuoy2Anhm3SrNmKeAZ3ycOHbgIvNQrSRf4Rys4Ve700Q7VLtl1f'

};
